import Cookies from 'universal-cookie'
import { jwtName } from '../constants';

export const nameOfVariable = obj => Object.keys(obj)[0];

export function isNeitherNullNorUndefined(value){
    return typeof(value) !== 'undefined' && value != null
}

export function logout(){
    console.log("LOGOUT!!!", jwtName)
    const cookies = new Cookies()
    cookies.remove(jwtName, { path: '/' })
    cookies.remove(jwtName, { path: '/prof/lerneinheiten/page' })

  
}

export function containsOnlyNumbers(str) {
    return /^\d+$/.test(str);
}


export function orderArrayOfObjectsByOtherArray (array, order, key) {
    array.sort( function (a, b) {
      var A = a[key], B = b[key];
      if (order.indexOf(A) > order.indexOf(B)) {
        return 1;
      } else {
        return -1;
      } 
    });
    return array;
  };
